module.exports = __webpack_public_path__ + "img/pc-help-3.1e03ba50.jpg";